"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPasswordHashDestination = void 0;
var tslib_1 = require("tslib");
var hex_stream_destination_1 = require("../base/hex-stream-destination");
var LegacyPasswordHashDestination = (function (_super) {
    tslib_1.__extends(LegacyPasswordHashDestination, _super);
    function LegacyPasswordHashDestination(importer, dataStream) {
        if (dataStream === void 0) { dataStream = []; }
        return _super.call(this, importer, dataStream) || this;
    }
    LegacyPasswordHashDestination.prototype.createClone = function () {
        return new LegacyPasswordHashDestination(this.importer, this.dataStream);
    };
    LegacyPasswordHashDestination.prototype.afterPopRtfState = function () {
        var value = this.getNumberArray();
        var result = [];
        for (var i = 3; i >= 0; i--)
            result.push(value[i]);
        this.importer.documentModel.documentProtectionProperties.word2003PasswordHash = new Uint8Array(result);
    };
    return LegacyPasswordHashDestination;
}(hex_stream_destination_1.HexStreamDestination));
exports.LegacyPasswordHashDestination = LegacyPasswordHashDestination;
